import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createBrand, deleteBrand, fetchAllBrands, fetchBrandById, updateBrand } from "./brandAPI";


const initialState = {
  status: "idle",
  allBrands: null,
  totalBrands: null,
  newBrandAdded:null,
  selectedBrand:null,
};


export const updateBrandAsync = createAsyncThunk(
  "brand/updateBrand",
  async (update) => {
    // this is name mistake
    const response = await updateBrand(update);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const createBrandAsync = createAsyncThunk(
    "brand/createBrand",
    async (brand) => {
      const response = await createBrand(brand);
      // The value we return becomes the `fulfilled` action payload
      return response.data;
    }
  );

export const deleteBrandAsync = createAsyncThunk(
  "brand/deleteBrand",
  async (id) => {
    const response = await deleteBrand(id);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const fetchBrandByIdAsync = createAsyncThunk(
    'brand/fetchBrandById',
    async (id) => {
      const response = await fetchBrandById(id);
      // The value we return becomes the `fulfilled` action payload
      return response.data;
    }
  );


export const fetchAllBrandsAsync = createAsyncThunk(
  "brand/fetchAllBrands",
  async ({ sort, pagination }) => {
    const response = await fetchAllBrands(sort, pagination);
    // The value we return becomes the `fulfilled` action payload
    return response.data;
  }
);

export const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    clearSelectedBrand:(state)=>{
      state.selectedBrand = null
    }
  },
  extraReducers: (builder) => {
    builder
    .addCase(createBrandAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createBrandAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.newBrandAdded = action.payload;
        state.allBrands.push(action.payload);
      })
      .addCase(fetchAllBrandsAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAllBrandsAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.allBrands = action.payload.brands;
        state.totalBrands = action.payload.totalBrands;
      })
      .addCase(deleteBrandAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(deleteBrandAsync.fulfilled, (state, action) => {
        state.status = "idle";
        // Assuming action.payload contains the ID of the deleted brand
        const deletedBrandId = action.payload;

        // Filter out the deleted brand from state.allbrands array
        const updatedAllBrands = state.allBrands.filter(
          (brand) => brand.id !== deletedBrandId
        );
        state.allBrands = updatedAllBrands;
        state.totalBrands = state.totalBrands - 1;
        state.selectedBrand=null;
      })
      .addCase(updateBrandAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateBrandAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        const index = state.allBrands.findIndex(
          (brand) => brand.id === action.payload.id
        );
        state.allBrands[index] = action.payload;
        state.selectedBrand = action.payload;

      })
      .addCase(fetchBrandByIdAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchBrandByIdAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.selectedBrand = action.payload;
      });;
  },
});

export const { clearSelectedBrand } = brandSlice.actions;
export const selectBrands = (state) => state.brand.allBrands;
export const selectTotalBrands = (state) => state.brand.totalBrands;
export const selectBrandById = (state) => state.brand.selectedBrand;


export default brandSlice.reducer;
